import React, { useEffect, createContext, useContext, useReducer } from 'react';

const initState = {
  rowsPerPage: 10,
  companyId: null,
  companyTimezone: null,
  userId: null,
  empId: null,
  isOpenNavbar: false,
  companyCurrency: null,
  companyCurrencyAr: null,
  changeRowsPerPage: () => { },
  setCompanyId: () => { },
  setCompanyTimezone: () => { },
  toggleOpenNavbar: () => { },
  setUserId: () => { },
  setCompanyCurrency: () => { },
  setCompanyCurrencyAr: () => { },
};

const AppContext = createContext(initState);

const SET_ROWS_PER_PAGE = 'SET_ROWS_PER_PAGE';
const SET_COMPANY_ID = 'SET_COMPANY_ID';
const SET_COMPANY_TIMEZONE = 'SET_COMPANY_TIMEZONE';
const SET_ACTIVE_USERID = 'SET_ACTIVE_USERID';
const SET_ACTIVE_EMPID = 'SET_ACTIVE_EMPID';
const TOGGLE_OPEN_NAVBAR = 'TOGGLE_OPEN_NAVBAR';
const TOGGLE_COMPANY_CURRENCY = 'TOGGLE_COMPANY_CURRENCY';
const TOGGLE_COMPANY_CURRENCY_AR = 'TOGGLE_COMPANY_CURRENCY_AR';

function appReducer(state, action) {
  switch (action.type) {
    case SET_ROWS_PER_PAGE:
      return { ...state, rowsPerPage: action.payload };
    case SET_COMPANY_ID: {
      return { ...state, companyId: action.payload };
    }
    case TOGGLE_COMPANY_CURRENCY: {
      return { ...state, companyCurrency: action.payload };
    }
    case TOGGLE_COMPANY_CURRENCY_AR: {
      return { ...state, companyCurrencyAr: action.payload };
    }
    case SET_COMPANY_TIMEZONE: {
      return { ...state, companyTimezone: action.payload };
    }
    case SET_ACTIVE_USERID: {
      return { ...state, userId: action.payload };
    }
    case SET_ACTIVE_EMPID: {
      return { ...state, empId: action.payload };
    }
    case TOGGLE_OPEN_NAVBAR: {
      return {
        ...state,
        isOpenNavbar: !{ ...state }.isOpenNavbar,
      };
    }
    default:
      return state;
  }
}

export function AppProvider({ children }) {
  const changeRowsPerPage = (newRowsPerPage) => {
    if (newRowsPerPage !== undefined)
      dispatch({ type: SET_ROWS_PER_PAGE, payload: newRowsPerPage });
  };

  const setCompanyId = (id) => {
    dispatch({ type: SET_COMPANY_ID, payload: id });
  };
  const setCompanyTimezone = (id) => {
    dispatch({ type: SET_COMPANY_TIMEZONE, payload: id });
  };

  const toggleOpenNavbar = () => {
    dispatch({ type: TOGGLE_OPEN_NAVBAR });
  };

  const setUserId = (id) => {
    dispatch({ type: SET_ACTIVE_USERID, payload: id });
  };

  const setEmpId = (id) => {
    dispatch({ type: SET_ACTIVE_EMPID, payload: id });
  };

  const setCompanyCurrency = (id) => {
    dispatch({ type: TOGGLE_COMPANY_CURRENCY, payload: id });
  };

  const setCompanyCurrencyAr = (id) => {
    dispatch({ type: TOGGLE_COMPANY_CURRENCY_AR, payload: id });
  };

  const [state, dispatch] = useReducer(appReducer, initState);

  const value = {
    rowsPerPage: state.rowsPerPage,
    companyId: state.companyId,
    companyTimezone: state.companyTimezone,
    userId: state.userId,
    empId: state.empId,
    isOpenNavbar: state.isOpenNavbar,
    companyCurrency: state.companyCurrency,
    companyCurrencyAr: state.companyCurrencyAr,
    changeRowsPerPage,
    setCompanyId,
    toggleOpenNavbar,
    setUserId,
    setEmpId,
    setCompanyTimezone,
    setCompanyCurrency,
    setCompanyCurrencyAr,
  };

  useEffect(() => {
    const companyId = localStorage.getItem('__current_company_id');
    const companyCurrency = localStorage.getItem('company_currency');
    const companyCurrencyAr = localStorage.getItem('company_currency_ar');
    const userId = localStorage.getItem('__active__user__id');
    const empId = JSON.parse(localStorage.getItem('__active__user__info'));
    const storedTz = localStorage.getItem('company_timezone');
    const Timezone = storedTz && storedTz !== 'undefined' && storedTz !== 'null' ? localStorage.getItem('company_timezone') : 'Asia/Dubai';

    setCompanyTimezone(Timezone);
    setCompanyId(companyId);
    setUserId(userId);
    setEmpId(empId?.emp_id);
    setCompanyCurrency(companyCurrency);
    setCompanyCurrencyAr(companyCurrencyAr);
  }, []);

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export function useApp() {
  const app = useContext(AppContext);

  return { ...app };
}
